/**
 * Whether the supplier may still change an application.
 *
 * Only two states hand the application to the supplier: a draft they have not
 * submitted, and one a reviewer returned for amendment. Everything else is
 * either in review or decided, and the server refuses edits to it
 * (Supplier.canSubmit), so the form is read-only there and nowhere else.
 */
export const EDITABLE_STATUSES = ['draft', 'more_info_required'];

// A new application has no status yet and is, by definition, editable.
export const isApplicationEditable = (status) => !status || EDITABLE_STATUSES.includes(status);
